import script from "./EarthquakeUdcSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./EarthquakeUdcSelect.vue?vue&type=script&setup=true&lang=ts"

import "./EarthquakeUdcSelect.vue?vue&type=style&index=0&id=4315e11b&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4315e11b"]])

export default __exports__